import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import Panel from '../components/Panel';
import { IconRadar, IconCalendar } from '../components/icons';

export default function EventForecast() {
  const { loading, data, live } = useApi(() => api.eventForecast());
  const evts = data?.evenements || [];

  return (
    <>
      <Topbar title="Prévision de la demande événementielle" subtitle="Anticipation des grands rassemblements" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <div className="grid grid--halves">
            {evts.map((e, i) => (
              <Panel key={i} icon={IconCalendar} title={e.nom} sub={new Date(e.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} delay={i * 80}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 10 }}>
                  <span className="bignum" style={{ fontSize: 38, color: 'var(--teal)' }}>×{e.uplift}</span>
                  <span style={{ color: 'var(--muted)', fontSize: 13 }}>hausse de demande prévue</span>
                </div>
                <div style={{ marginBottom: 12 }}>
                  {e.zones.map((z) => <span key={z} className="tag tag--amber" style={{ marginRight: 6 }}>{z}</span>)}
                </div>
                <div className="flow__bar"><div className="flow__fill" style={{ width: `${e.confiance * 100}%` }} /></div>
                <div className="panel__sub" style={{ marginTop: 6 }}>Confiance du modèle : {Math.round(e.confiance * 100)}%</div>
              </Panel>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
